import React from "react";
import "./ReconciliationFilter.css";

interface ReconciliationFilterProps {
  activeFilter: string;
  onChange: (filter: string) => void;
  counts: {
    all: number;
    matched: number;
    missing: number;
  };
}

const ReconciliationFilter: React.FC<ReconciliationFilterProps> = ({
  activeFilter,
  onChange,
  counts,
}) => {
  return (
    <div className="recon-filter" aria-label="Filter reconciliation rows">
      <button
        type="button"
        className={`recon-count ${activeFilter === "All" ? "active" : ""}`}
        aria-pressed={activeFilter === "All"}
        onClick={() => onChange("All")}
      >
        {counts.all} lines
      </button>
      <button
        type="button"
        className={`recon-count ${activeFilter === "Matched" ? "active" : ""}`}
        aria-pressed={activeFilter === "Matched"}
        onClick={() => onChange("Matched")}
      >
        {counts.matched} Matched
      </button>
      <button
        type="button"
        className={`recon-count ${activeFilter === "Missing" ? "active" : ""}`}
        aria-pressed={activeFilter === "Missing"}
        onClick={() => onChange("Missing")}
      >
        {counts.missing} Missing
      </button>
    </div>
  );
};

export default ReconciliationFilter;
